export default [
    {
        date: 1584712332390,
        row: 28,
        col: 28,
        squares: [
            [3, 4, "#000000"],
            [4, 5, "#000000"],
            [5, 6, "#000000"],
            [6, 6, "#000000"],
            [7, 7, "#000000"],
            [8, 7, "#000000"],
            [9, 7, "#000000"],
            [4, 3, "#000000"],
            [5, 2, "#000000"],
            [6, 2, "#000000"],
            [7, 2, "#000000"],
            [8, 2, "#000000"],
            [9, 2, "#000000"],
            [10, 3, "#000000"],
            [11, 4, "#000000"],
            [12, 5, "#000000"],
            [13, 6, "#000000"],
            [14, 5, "#000000"],
            [15, 4, "#000000"],
            [16, 4, "#000000"],
            [17, 3, "#000000"],
            [18, 3, "#000000"],
            [19, 3, "#000000"],
            [20, 3, "#000000"],
            [21, 4, "#000000"],
            [22, 5, "#000000"],
            [23, 6, "#000000"],
            [10, 8, "#000000"],
            [10, 9, "#000000"],
            [9, 10, "#000000"],
            [9, 11, "#000000"],
            [9, 12, "#000000"],
            [9, 13, "#000000"],
            [9, 14, "#000000"],
            [9, 15, "#000000"],
            [5, 27, "#000000"],
            [9, 27, "#000000"],
            [8, 27, "#000000"],
            [6, 27, "#000000"],
            [7, 27, "#000000"],
            [4, 26, "#000000"],
            [3, 25, "#000000"],
            [4, 24, "#000000"],
            [5, 23, "#000000"],
            [6, 23, "#000000"],
            [7, 22, "#000000"],
            [8, 22, "#000000"],
            [9, 22, "#000000"],
            [10, 21, "#000000"],
            [10, 20, "#000000"],
            [9, 19, "#000000"],
            [9, 18, "#000000"],
            [9, 17, "#000000"],
            [9, 16, "#000000"],
            [10, 26, "#000000"],
            [11, 25, "#000000"],
            [12, 24, "#000000"],
            [13, 23, "#000000"],
            [14, 24, "#000000"],
            [15, 25, "#000000"],
            [16, 25, "#000000"],
            [20, 26, "#000000"],
            [19, 26, "#000000"],
            [18, 26, "#000000"],
            [17, 26, "#000000"],
            [21, 25, "#000000"],
            [22, 24, "#000000"],
            [23, 23, "#000000"],
            [24, 22, "#000000"],
            [25, 21, "#000000"],
            [25, 20, "#000000"],
            [26, 19, "#000000"],
            [24, 7, "#000000"],
            [25, 8, "#000000"],
            [25, 9, "#000000"],
            [26, 10, "#000000"],
            [26, 11, "#000000"],
            [26, 12, "#000000"],
            [26, 13, "#000000"],
            [26, 14, "#000000"],
            [26, 15, "#000000"],
            [26, 17, "#000000"],
            [26, 18, "#000000"],
            [26, 16, "#000000"],
            [15, 11, "#000000"],
            [15, 12, "#000000"],
            [16, 13, "#000000"],
            [17, 13, "#000000"],
            [18, 12, "#000000"],
            [18, 11, "#000000"],
            [17, 10, "#000000"],
            [16, 10, "#000000"],
            [15, 18, "#000000"],
            [15, 19, "#000000"],
            [16, 20, "#000000"],
            [17, 20, "#000000"],
            [18, 19, "#000000"],
            [18, 18, "#000000"],
            [17, 17, "#000000"],
            [16, 17, "#000000"],
            [16, 11, "#000000"],
            [17, 12, "#000000"],
            [16, 18, "#000000"],
            [17, 19, "#000000"],
            [22, 15, "#FF00FF"],
            [21, 16, "#FF00FF"],
            [20, 17, "#FF00FF"],
            [20, 16, "#FF00FF"],
            [20, 15, "#FF00FF"],
            [21, 14, "#FF00FF"],
            [20, 13, "#FF00FF"],
            [20, 14, "#FF00FF"],
            [21, 15, "#FF00FF"],
            [23, 16, "#000000"],
            [24, 17, "#000000"],
            [24, 18, "#000000"],
            [24, 19, "#000000"],
            [23, 20, "#000000"],
            [23, 14, "#000000"],
            [24, 13, "#000000"],
            [24, 12, "#000000"],
            [24, 11, "#000000"],
            [23, 10, "#000000"],
            [10, 23, "#FF00FF"],
            [10, 24, "#FF00FF"],
            [9, 25, "#FF00FF"],
            [8, 25, "#FF00FF"],
            [7, 25, "#FF00FF"],
            [6, 25, "#FF00FF"],
            [6, 24, "#FF00FF"],
            [7, 24, "#FF00FF"],
            [8, 24, "#FF00FF"],
            [9, 24, "#FF00FF"],
            [7, 5, "#FF00FF"],
            [8, 5, "#FF00FF"],
            [9, 5, "#FF00FF"],
            [10, 6, "#FF00FF"],
            [10, 5, "#FF00FF"],
            [9, 4, "#FF00FF"],
            [8, 4, "#FF00FF"],
            [7, 4, "#FF00FF"],
            [6, 4, "#FF00FF"],
            [6, 5, "#FF00FF"],
            [24, 14, "#FF0000"],
            [24, 15, "#FF0000"],
            [24, 16, "#FF0000"],
            [25, 15, "#FF0000"],
            [10, 4, "#00FFFF"],
            [9, 3, "#00FFFF"],
            [8, 3, "#00FFFF"],
            [7, 3, "#00FFFF"],
            [5, 3, "#00FFFF"],
            [6, 3, "#00FFFF"],
            [5, 4, "#00FFFF"],
            [4, 4, "#00FFFF"],
            [5, 5, "#00FFFF"],
            [8, 6, "#00FFFF"],
            [7, 6, "#00FFFF"],
            [9, 6, "#00FFFF"],
            [10, 7, "#00FFFF"],
            [11, 7, "#00FFFF"],
            [11, 6, "#00FFFF"],
            [11, 5, "#00FFFF"],
            [11, 8, "#00FFFF"],
            [11, 9, "#00FFFF"],
            [11, 11, "#00FFFF"],
            [11, 12, "#00FFFF"],
            [11, 15, "#00FFFF"],
            [11, 16, "#00FFFF"],
            [11, 17, "#00FFFF"],
            [10, 19, "#00FFFF"],
            [11, 20, "#00FFFF"],
            [11, 19, "#00FFFF"],
            [11, 18, "#00FFFF"],
            [10, 18, "#00FFFF"],
            [10, 16, "#00FFFF"],
            [10, 17, "#00FFFF"],
            [10, 15, "#00FFFF"],
            [10, 14, "#00FFFF"],
            [10, 13, "#00FFFF"],
            [10, 11, "#00FFFF"],
            [10, 12, "#00FFFF"],
            [10, 10, "#00FFFF"],
            [11, 10, "#00FFFF"],
            [11, 14, "#00FFFF"],
            [11, 13, "#00FFFF"],
            [11, 21, "#00FFFF"],
            [10, 22, "#00FFFF"],
            [9, 23, "#00FFFF"],
            [8, 23, "#00FFFF"],
            [7, 23, "#00FFFF"],
            [5, 24, "#00FFFF"],
            [5, 25, "#00FFFF"],
            [4, 25, "#00FFFF"],
            [5, 26, "#00FFFF"],
            [6, 26, "#00FFFF"],
            [7, 26, "#00FFFF"],
            [8, 26, "#00FFFF"],
            [9, 26, "#00FFFF"],
            [10, 25, "#00FFFF"],
            [11, 24, "#00FFFF"],
            [11, 23, "#00FFFF"],
            [11, 22, "#00FFFF"],
            [12, 15, "#00FFFF"],
            [13, 15, "#00FFFF"],
            [14, 15, "#00FFFF"],
            [15, 15, "#00FFFF"],
            [16, 15, "#00FFFF"],
            [17, 15, "#00FFFF"],
            [18, 15, "#00FFFF"],
            [19, 15, "#00FFFF"],
            [19, 14, "#00FFFF"],
            [18, 14, "#00FFFF"],
            [17, 14, "#00FFFF"],
            [16, 14, "#00FFFF"],
            [15, 14, "#00FFFF"],
            [14, 14, "#00FFFF"],
            [13, 14, "#00FFFF"],
            [12, 14, "#00FFFF"],
            [12, 16, "#00FFFF"],
            [13, 16, "#00FFFF"],
            [14, 16, "#00FFFF"],
            [15, 16, "#00FFFF"],
            [17, 16, "#00FFFF"],
            [16, 16, "#00FFFF"],
            [19, 16, "#00FFFF"],
            [18, 16, "#00FFFF"],
            [18, 17, "#00FFFF"],
            [19, 17, "#00FFFF"],
            [18, 13, "#00FFFF"],
            [19, 13, "#00FFFF"],
            [15, 13, "#00FFFF"],
            [14, 13, "#00FFFF"],
            [13, 13, "#00FFFF"],
            [12, 13, "#00FFFF"],
            [15, 17, "#00FFFF"],
            [14, 17, "#00FFFF"],
            [13, 17, "#00FFFF"],
            [12, 17, "#00FFFF"],
            [12, 18, "#00FFFF"],
            [13, 18, "#00FFFF"],
            [14, 18, "#00FFFF"],
            [14, 19, "#00FFFF"],
            [13, 19, "#00FFFF"],
            [12, 19, "#00FFFF"],
            [14, 12, "#00FFFF"],
            [13, 12, "#00FFFF"],
            [12, 12, "#00FFFF"],
            [13, 11, "#00FFFF"],
            [14, 11, "#00FFFF"],
            [12, 11, "#00FFFF"],
            [12, 10, "#00FFFF"],
            [13, 10, "#00FFFF"],
            [14, 10, "#00FFFF"],
            [15, 10, "#00FFFF"],
            [15, 20, "#00FFFF"],
            [14, 20, "#00FFFF"],
            [12, 20, "#00FFFF"],
            [13, 20, "#00FFFF"],
            [23, 15, "#00FFFF"],
            [22, 16, "#00FFFF"],
            [21, 17, "#00FFFF"],
            [22, 17, "#00FFFF"],
            [22, 18, "#00FFFF"],
            [23, 18, "#00FFFF"],
            [23, 17, "#00FFFF"],
            [23, 19, "#00FFFF"],
            [25, 19, "#00FFFF"],
            [25, 18, "#00FFFF"],
            [25, 17, "#00FFFF"],
            [25, 16, "#00FFFF"],
            [25, 14, "#00FFFF"],
            [25, 13, "#00FFFF"],
            [25, 12, "#00FFFF"],
            [25, 10, "#00FFFF"],
            [25, 11, "#00FFFF"],
            [24, 10, "#00FFFF"],
            [24, 9, "#00FFFF"],
            [24, 8, "#00FFFF"],
            [23, 8, "#00FFFF"],
            [23, 9, "#00FFFF"],
            [23, 7, "#00FFFF"],
            [22, 7, "#00FFFF"],
            [22, 6, "#00FFFF"],
            [21, 5, "#00FFFF"],
            [19, 4, "#00FFFF"],
            [20, 4, "#00FFFF"],
            [21, 7, "#00FFFF"],
            [20, 6, "#00FFFF"],
            [21, 6, "#00FFFF"],
            [20, 5, "#00FFFF"],
            [19, 5, "#00FFFF"],
            [18, 5, "#00FFFF"],
            [17, 5, "#00FFFF"],
            [16, 5, "#00FFFF"],
            [15, 5, "#00FFFF"],
            [18, 4, "#00FFFF"],
            [17, 4, "#00FFFF"],
            [19, 6, "#00FFFF"],
            [18, 6, "#00FFFF"],
            [17, 6, "#00FFFF"],
            [16, 6, "#00FFFF"],
            [15, 6, "#00FFFF"],
            [14, 6, "#00FFFF"],
            [13, 7, "#00FFFF"],
            [12, 7, "#00FFFF"],
            [15, 7, "#00FFFF"],
            [17, 7, "#00FFFF"],
            [19, 7, "#00FFFF"],
            [20, 7, "#00FFFF"],
            [18, 7, "#00FFFF"],
            [16, 7, "#00FFFF"],
            [14, 7, "#00FFFF"],
            [12, 6, "#00FFFF"],
            [12, 8, "#00FFFF"],
            [14, 8, "#00FFFF"],
            [15, 8, "#00FFFF"],
            [17, 8, "#00FFFF"],
            [18, 8, "#00FFFF"],
            [20, 8, "#00FFFF"],
            [21, 8, "#00FFFF"],
            [22, 8, "#00FFFF"],
            [16, 8, "#00FFFF"],
            [19, 8, "#00FFFF"],
            [13, 8, "#00FFFF"],
            [13, 9, "#00FFFF"],
            [12, 9, "#00FFFF"],
            [14, 9, "#00FFFF"],
            [15, 9, "#00FFFF"],
            [16, 9, "#00FFFF"],
            [17, 9, "#00FFFF"],
            [18, 9, "#00FFFF"],
            [19, 9, "#00FFFF"],
            [21, 9, "#00FFFF"],
            [20, 9, "#00FFFF"],
            [22, 9, "#00FFFF"],
            [22, 10, "#00FFFF"],
            [23, 11, "#00FFFF"],
            [23, 12, "#00FFFF"],
            [23, 13, "#00FFFF"],
            [22, 14, "#00FFFF"],
            [22, 13, "#00FFFF"],
            [21, 13, "#00FFFF"],
            [21, 12, "#00FFFF"],
            [20, 12, "#00FFFF"],
            [19, 12, "#00FFFF"],
            [19, 11, "#00FFFF"],
            [19, 10, "#00FFFF"],
            [18, 10, "#00FFFF"],
            [21, 11, "#00FFFF"],
            [21, 10, "#00FFFF"],
            [20, 10, "#00FFFF"],
            [20, 11, "#00FFFF"],
            [22, 11, "#00FFFF"],
            [22, 12, "#00FFFF"],
            [24, 21, "#00FFFF"],
            [24, 20, "#00FFFF"],
            [23, 21, "#00FFFF"],
            [22, 21, "#00FFFF"],
            [21, 21, "#00FFFF"],
            [19, 21, "#00FFFF"],
            [20, 21, "#00FFFF"],
            [18, 21, "#00FFFF"],
            [17, 21, "#00FFFF"],
            [15, 21, "#00FFFF"],
            [16, 21, "#00FFFF"],
            [14, 21, "#00FFFF"],
            [12, 22, "#00FFFF"],
            [12, 21, "#00FFFF"],
            [13, 21, "#00FFFF"],
            [13, 22, "#00FFFF"],
            [12, 23, "#00FFFF"],
            [14, 22, "#00FFFF"],
            [15, 22, "#00FFFF"],
            [16, 22, "#00FFFF"],
            [17, 22, "#00FFFF"],
            [18, 22, "#00FFFF"],
            [19, 22, "#00FFFF"],
            [20, 22, "#00FFFF"],
            [21, 22, "#00FFFF"],
            [22, 22, "#00FFFF"],
            [23, 22, "#00FFFF"],
            [22, 20, "#00FFFF"],
            [21, 20, "#00FFFF"],
            [20, 20, "#00FFFF"],
            [19, 20, "#00FFFF"],
            [18, 20, "#00FFFF"],
            [19, 18, "#00FFFF"],
            [19, 19, "#00FFFF"],
            [20, 18, "#00FFFF"],
            [20, 19, "#00FFFF"],
            [21, 19, "#00FFFF"],
            [22, 19, "#00FFFF"],
            [21, 18, "#00FFFF"],
            [14, 23, "#00FFFF"],
            [15, 23, "#00FFFF"],
            [17, 23, "#00FFFF"],
            [19, 23, "#00FFFF"],
            [20, 23, "#00FFFF"],
            [21, 23, "#00FFFF"],
            [22, 23, "#00FFFF"],
            [20, 24, "#00FFFF"],
            [21, 24, "#00FFFF"],
            [19, 24, "#00FFFF"],
            [18, 24, "#00FFFF"],
            [17, 24, "#00FFFF"],
            [16, 24, "#00FFFF"],
            [15, 24, "#00FFFF"],
            [16, 23, "#00FFFF"],
            [18, 23, "#00FFFF"],
            [17, 25, "#00FFFF"],
            [18, 25, "#00FFFF"],
            [19, 25, "#00FFFF"],
            [20, 25, "#00FFFF"],
            [3, 23, "#9900FF"],
            [3, 22, "#9900FF"],
            [3, 19, "#9900FF"],
            [4, 17, "#9900FF"],
            [5, 15, "#9900FF"],
            [5, 12, "#9900FF"],
            [4, 11, "#9900FF"],
            [6, 10, "#00FF00"],
            [7, 9, "#9900FF"],
            [8, 8, "#9900FF"],
            [7, 8, "#9900FF"],
            [9, 8, "#9900FF"],
            [9, 9, "#9900FF"],
            [8, 9, "#9900FF"],
            [8, 10, "#9900FF"],
            [8, 11, "#9900FF"],
            [8, 12, "#9900FF"],
            [8, 14, "#9900FF"],
            [8, 13, "#9900FF"],
            [7, 13, "#9900FF"],
            [6, 13, "#00FF00"],
            [5, 13, "#9900FF"],
            [4, 13, "#9900FF"],
            [3, 13, "#9900FF"],
            [1, 13, "#9900FF"],
            [2, 13, "#9900FF"],
            [4, 12, "#9900FF"],
            [3, 12, "#9900FF"],
            [2, 11, "#00FF00"],
            [2, 12, "#00FF00"],
            [1, 12, "#00FF00"],
            [2, 10, "#00FF00"],
            [3, 7, "#9900FF"],
            [3, 8, "#00FF00"],
            [5, 8, "#00FF00"],
            [5, 9, "#00FF00"],
            [1, 4, "#00FF00"],
            [1, 3, "#9900FF"],
            [2, 2, "#9900FF"],
            [3, 1, "#00FF00"],
            [11, 1, "#00FF00"],
            [8, 1, "#00FF00"],
            [5, 1, "#00FF00"],
            [13, 4, "#00FF00"],
            [14, 2, "#9900FF"],
            [13, 1, "#00FF00"],
            [12, 2, "#9900FF"],
            [17, 1, "#00FF00"],
            [17, 2, "#FF0000"],
            [21, 1, "#00FF00"],
            [24, 1, "#00FF00"],
            [24, 3, "#00FF00"],
            [25, 4, "#00FF00"],
            [23, 4, "#FF0000"],
            [22, 2, "#9900FF"],
            [18, 1, "#00FF00"],
            [6, 19, "#00FF00"],
            [7, 20, "#9900FF"],
            [8, 20, "#9900FF"],
            [7, 17, "#9900FF"],
            [3, 16, "#9900FF"],
            [2, 17, "#00FF00"],
            [6, 12, "#00FF00"],
            [7, 12, "#9900FF"],
            [7, 14, "#9900FF"],
            [6, 14, "#00FF00"],
            [4, 14, "#00FF00"],
            [5, 14, "#9900FF"],
            [3, 14, "#00FF00"],
            [2, 14, "#9900FF"],
            [1, 14, "#9900FF"],
            [1, 15, "#9900FF"],
            [1, 16, "#9900FF"],
            [1, 18, "#0000FF"],
            [1, 17, "#00FF00"],
            [1, 19, "#00FF00"],
            [1, 20, "#9900FF"],
            [1, 21, "#00FF00"],
            [1, 22, "#9900FF"],
            [1, 23, "#00FF00"],
            [1, 24, "#9900FF"],
            [1, 25, "#00FF00"],
            [1, 26, "#9900FF"],
            [1, 27, "#00FF00"],
            [1, 28, "#00FF00"],
            [1, 10, "#00FF00"],
            [1, 11, "#0000FF"],
            [1, 9, "#9900FF"],
            [1, 7, "#9900FF"],
            [1, 8, "#00FF00"],
            [1, 5, "#9900FF"],
            [1, 6, "#00FF00"],
            [1, 2, "#00FF00"],
            [1, 1, "#00FF00"],
            [2, 1, "#00FF00"],
            [2, 3, "#00FF00"],
            [2, 4, "#9900FF"],
            [2, 5, "#00FF00"],
            [2, 7, "#9900FF"],
            [2, 6, "#9900FF"],
            [2, 8, "#00FF00"],
            [2, 9, "#9900FF"],
            [2, 16, "#9900FF"],
            [2, 15, "#9900FF"],
            [4, 15, "#00FF00"],
            [3, 15, "#00FF00"],
            [4, 16, "#9900FF"],
            [6, 16, "#00FF00"],
            [5, 16, "#9900FF"],
            [7, 15, "#9900FF"],
            [6, 15, "#00FF00"],
            [7, 16, "#9900FF"],
            [8, 15, "#9900FF"],
            [8, 16, "#9900FF"],
            [8, 17, "#9900FF"],
            [8, 18, "#9900FF"],
            [8, 19, "#9900FF"],
            [9, 20, "#9900FF"],
            [9, 21, "#9900FF"],
            [8, 21, "#9900FF"],
            [7, 21, "#9900FF"],
            [5, 21, "#00FF00"],
            [6, 22, "#9900FF"],
            [6, 21, "#9900FF"],
            [5, 22, "#9900FF"],
            [4, 22, "#9900FF"],
            [4, 23, "#9900FF"],
            [3, 24, "#9900FF"],
            [2, 25, "#9900FF"],
            [3, 26, "#9900FF"],
            [2, 26, "#00FF00"],
            [3, 27, "#00FF00"],
            [4, 27, "#9900FF"],
            [4, 28, "#00FF00"],
            [5, 28, "#00FF00"],
            [6, 28, "#00FF00"],
            [7, 28, "#00FF00"],
            [8, 28, "#00FF00"],
            [9, 28, "#00FF00"],
            [10, 28, "#00FF00"],
            [11, 28, "#00FF00"],
            [11, 27, "#00FF00"],
            [12, 26, "#00FF00"],
            [12, 27, "#9900FF"],
            [10, 27, "#FF0000"],
            [11, 26, "#FF0000"],
            [12, 25, "#FF0000"],
            [13, 26, "#9900FF"],
            [13, 24, "#FF0000"],
            [13, 25, "#00FF00"],
            [14, 25, "#FF0000"],
            [14, 26, "#00FF00"],
            [14, 27, "#9900FF"],
            [14, 28, "#00FF00"],
            [13, 28, "#00FF00"],
            [12, 28, "#00FF00"],
            [13, 27, "#00FF00"],
            [2, 28, "#00FF00"],
            [3, 28, "#00FF00"],
            [2, 27, "#9900FF"],
            [2, 24, "#00FF00"],
            [2, 23, "#9900FF"],
            [2, 22, "#9900FF"],
            [2, 21, "#00FF00"],
            [3, 20, "#9900FF"],
            [3, 21, "#00FF00"],
            [4, 21, "#00FF00"],
            [4, 20, "#9900FF"],
            [4, 19, "#9900FF"],
            [4, 18, "#9900FF"],
            [3, 18, "#9900FF"],
            [2, 18, "#00FF00"],
            [2, 19, "#00FF00"],
            [2, 20, "#9900FF"],
            [3, 17, "#9900FF"],
            [5, 17, "#9900FF"],
            [6, 17, "#00FF00"],
            [6, 18, "#00FF00"],
            [5, 18, "#9900FF"],
            [5, 19, "#9900FF"],
            [5, 20, "#00FF00"],
            [6, 20, "#9900FF"],
            [7, 19, "#9900FF"],
            [7, 18, "#9900FF"],
            [7, 10, "#9900FF"],
            [7, 11, "#9900FF"],
            [6, 11, "#00FF00"],
            [5, 11, "#9900FF"],
            [5, 10, "#9900FF"],
            [4, 10, "#9900FF"],
            [3, 10, "#9900FF"],
            [3, 11, "#9900FF"],
            [3, 9, "#9900FF"],
            [4, 9, "#9900FF"],
            [4, 7, "#9900FF"],
            [4, 8, "#00FF00"],
            [5, 7, "#9900FF"],
            [6, 7, "#9900FF"],
            [6, 8, "#9900FF"],
            [6, 9, "#9900FF"],
            [4, 6, "#9900FF"],
            [3, 6, "#9900FF"],
            [3, 5, "#9900FF"],
            [3, 3, "#9900FF"],
            [3, 2, "#00FF00"],
            [4, 2, "#9900FF"],
            [4, 1, "#00FF00"],
            [7, 1, "#00FF00"],
            [6, 1, "#00FF00"],
            [9, 1, "#00FF00"],
            [10, 1, "#00FF00"],
            [12, 1, "#00FF00"],
            [14, 1, "#00FF00"],
            [15, 1, "#00FF00"],
            [14, 4, "#FF0000"],
            [14, 3, "#00FF00"],
            [13, 2, "#00FF00"],
            [13, 3, "#9900FF"],
            [12, 3, "#00FF00"],
            [11, 3, "#FF0000"],
            [11, 2, "#00FF00"],
            [10, 2, "#FF0000"],
            [13, 5, "#FF0000"],
            [12, 4, "#FF0000"],
            [15, 3, "#FF0000"],
            [16, 3, "#9900FF"],
            [16, 2, "#FF0000"],
            [15, 2, "#00FF00"],
            [16, 1, "#00FF00"],
            [18, 2, "#FF0000"],
            [20, 2, "#FF0000"],
            [19, 2, "#FF0000"],
            [21, 2, "#FF0000"],
            [23, 2, "#00FF00"],
            [24, 2, "#9900FF"],
            [25, 2, "#00FF00"],
            [27, 2, "#00FF00"],
            [28, 2, "#00FF00"],
            [26, 2, "#9900FF"],
            [27, 1, "#00FF00"],
            [28, 1, "#00FF00"],
            [26, 1, "#00FF00"],
            [25, 1, "#00FF00"],
            [23, 1, "#00FF00"],
            [22, 1, "#00FF00"],
            [20, 1, "#00FF00"],
            [19, 1, "#00FF00"],
            [21, 3, "#9900FF"],
            [22, 3, "#FF0000"],
            [23, 3, "#9900FF"],
            [22, 4, "#9900FF"],
            [24, 4, "#9900FF"],
            [26, 4, "#9900FF"],
            [27, 4, "#00FF00"],
            [28, 4, "#00FF00"],
            [28, 3, "#00FF00"],
            [26, 3, "#00FF00"],
            [27, 3, "#9900FF"],
            [25, 3, "#9900FF"],
            [23, 5, "#9900FF"],
            [24, 5, "#FF0000"],
            [24, 6, "#9900FF"],
            [25, 6, "#FF0000"],
            [25, 7, "#9900FF"],
            [26, 7, "#FF0000"],
            [26, 8, "#9900FF"],
            [26, 9, "#9900FF"],
            [27, 10, "#9900FF"],
            [27, 11, "#9900FF"],
            [27, 9, "#9900FF"],
            [27, 12, "#9900FF"],
            [27, 13, "#9900FF"],
            [27, 14, "#9900FF"],
            [27, 15, "#9900FF"],
            [27, 17, "#9900FF"],
            [27, 16, "#9900FF"],
            [27, 18, "#9900FF"],
            [28, 19, "#00FF00"],
            [27, 19, "#9900FF"],
            [26, 20, "#9900FF"],
            [27, 20, "#9900FF"],
            [26, 21, "#9900FF"],
            [27, 21, "#FF0000"],
            [27, 22, "#9900FF"],
            [26, 22, "#FF0000"],
            [25, 22, "#9900FF"],
            [25, 23, "#FF0000"],
            [24, 23, "#9900FF"],
            [24, 24, "#FF0000"],
            [23, 24, "#9900FF"],
            [23, 25, "#FF0000"],
            [22, 25, "#9900FF"],
            [22, 26, "#FF0000"],
            [21, 26, "#9900FF"],
            [21, 27, "#FF0000"],
            [20, 27, "#FF0000"],
            [19, 27, "#FF0000"],
            [18, 27, "#FF0000"],
            [17, 27, "#FF0000"],
            [16, 27, "#FF0000"],
            [15, 27, "#00FF00"],
            [15, 26, "#FF0000"],
            [16, 26, "#9900FF"],
            [15, 28, "#00FF00"],
            [16, 28, "#00FF00"],
            [17, 28, "#00FF00"],
            [18, 28, "#00FF00"],
            [19, 28, "#00FF00"],
            [20, 28, "#00FF00"],
            [21, 28, "#00FF00"],
            [22, 28, "#00FF00"],
            [24, 28, "#00FF00"],
            [23, 28, "#00FF00"],
            [26, 28, "#00FF00"],
            [25, 28, "#00FF00"],
            [27, 28, "#00FF00"],
            [28, 28, "#00FF00"],
            [27, 27, "#00FF00"],
            [28, 27, "#00FF00"],
            [26, 27, "#9900FF"],
            [25, 27, "#00FF00"],
            [24, 27, "#9900FF"],
            [23, 27, "#00FF00"],
            [22, 27, "#9900FF"],
            [23, 26, "#9900FF"],
            [24, 26, "#00FF00"],
            [25, 26, "#9900FF"],
            [26, 26, "#00FF00"],
            [27, 26, "#9900FF"],
            [28, 26, "#00FF00"],
            [28, 25, "#00FF00"],
            [27, 25, "#00FF00"],
            [26, 25, "#9900FF"],
            [25, 25, "#00FF00"],
            [24, 25, "#9900FF"],
            [25, 24, "#9900FF"],
            [26, 24, "#00FF00"],
            [27, 24, "#9900FF"],
            [28, 24, "#00FF00"],
            [28, 23, "#00FF00"],
            [27, 23, "#00FF00"],
            [26, 23, "#9900FF"],
            [28, 22, "#00FF00"],
            [28, 21, "#00FF00"],
            [28, 20, "#00FF00"],
            [28, 17, "#00FF00"],
            [28, 18, "#00FF00"],
            [28, 14, "#00FF00"],
            [28, 16, "#00FF00"],
            [28, 15, "#00FF00"],
            [28, 13, "#00FF00"],
            [28, 12, "#00FF00"],
            [28, 11, "#00FF00"],
            [28, 10, "#00FF00"],
            [28, 8, "#00FF00"],
            [28, 9, "#00FF00"],
            [27, 8, "#FF0000"],
            [27, 6, "#00FF00"],
            [27, 7, "#9900FF"],
            [28, 7, "#00FF00"],
            [28, 6, "#00FF00"],
            [28, 5, "#00FF00"],
            [27, 5, "#9900FF"],
            [26, 5, "#00FF00"],
            [25, 5, "#9900FF"],
            [26, 6, "#9900FF"],
        ],
    },
    {
        date: 1520448142503,
        row: 28,
        col: 28,
        squares: [
            [1, 1, "#FF00FF"],
            [2, 2, "#FF00FF"],
            [3, 3, "#FF00FF"],
            [4, 4, "#FF00FF"],
            [5, 5, "#FF00FF"],
            [6, 4, "#FF0000"],
            [7, 3, "#980000"],
            [8, 2, "#980000"],
            [9, 1, "#980000"],
            [4, 6, "#980000"],
            [3, 7, "#980000"],
            [2, 8, "#980000"],
            [1, 9, "#980000"],
            [6, 6, "#FF00FF"],
            [7, 7, "#FF00FF"],
            [8, 8, "#FF00FF"],
            [9, 9, "#FF00FF"],
            [1, 28, "#FF00FF"],
            [2, 27, "#FF00FF"],
            [3, 26, "#FF00FF"],
            [4, 25, "#FF00FF"],
            [5, 24, "#FF00FF"],
            [6, 23, "#FF00FF"],
            [7, 22, "#FF00FF"],
            [8, 21, "#FF00FF"],
            [9, 20, "#FF00FF"],
            [10, 19, "#FF00FF"],
            [11, 18, "#FF00FF"],
            [12, 17, "#FF00FF"],
            [13, 16, "#FF00FF"],
            [14, 15, "#FF00FF"],
            [15, 14, "#FF00FF"],
            [16, 13, "#FF00FF"],
            [17, 12, "#FF00FF"],
            [18, 11, "#FF00FF"],
            [19, 10, "#FF00FF"],
            [20, 9, "#FF00FF"],
            [21, 8, "#FF00FF"],
            [22, 7, "#FF00FF"],
            [23, 6, "#FF00FF"],
            [24, 5, "#FF00FF"],
            [25, 4, "#FF00FF"],
            [26, 3, "#FF00FF"],
            [27, 2, "#FF00FF"],
            [28, 1, "#FF00FF"],
            [28, 28, "#FF00FF"],
            [27, 27, "#FF00FF"],
            [26, 26, "#FF00FF"],
            [25, 25, "#FF00FF"],
            [24, 24, "#FF00FF"],
            [23, 23, "#FF00FF"],
            [22, 22, "#FF00FF"],
            [21, 21, "#FF00FF"],
            [20, 20, "#FF00FF"],
            [19, 19, "#FF00FF"],
            [18, 18, "#FF00FF"],
            [17, 17, "#FF00FF"],
            [16, 16, "#FF00FF"],
            [15, 15, "#FF00FF"],
            [14, 14, "#FF00FF"],
            [13, 13, "#FF00FF"],
            [12, 12, "#FF00FF"],
            [11, 11, "#FF00FF"],
            [10, 10, "#FF00FF"],
            [14, 16, "#9900FF"],
            [15, 16, "#9900FF"],
            [14, 17, "#9900FF"],
            [15, 17, "#9900FF"],
            [14, 18, "#9900FF"],
            [15, 18, "#9900FF"],
            [14, 20, "#9900FF"],
            [14, 19, "#9900FF"],
            [15, 19, "#9900FF"],
            [15, 20, "#9900FF"],
            [15, 21, "#9900FF"],
            [15, 22, "#9900FF"],
            [15, 23, "#9900FF"],
            [14, 23, "#9900FF"],
            [14, 22, "#9900FF"],
            [14, 21, "#9900FF"],
            [14, 1, "#9900FF"],
            [14, 2, "#9900FF"],
            [14, 3, "#9900FF"],
            [14, 4, "#9900FF"],
            [14, 5, "#9900FF"],
            [14, 6, "#9900FF"],
            [14, 7, "#9900FF"],
            [14, 8, "#9900FF"],
            [15, 8, "#9900FF"],
            [15, 7, "#9900FF"],
            [15, 6, "#9900FF"],
            [15, 5, "#9900FF"],
            [15, 3, "#9900FF"],
            [15, 2, "#9900FF"],
            [15, 1, "#9900FF"],
            [15, 4, "#9900FF"],
            [13, 17, "#00FF00"],
            [13, 18, "#00FF00"],
            [12, 18, "#00FF00"],
            [12, 19, "#00FF00"],
            [11, 19, "#00FF00"],
            [11, 20, "#00FF00"],
            [10, 20, "#00FF00"],
            [10, 21, "#00FF00"],
            [9, 21, "#00FF00"],
            [9, 22, "#00FF00"],
            [8, 22, "#00FF00"],
            [10, 22, "#00FF00"],
            [11, 22, "#00FF00"],
            [12, 22, "#00FF00"],
            [13, 22, "#00FF00"],
            [13, 21, "#00FF00"],
            [13, 20, "#00FF00"],
            [13, 19, "#00FF00"],
            [12, 20, "#00FF00"],
            [12, 21, "#00FF00"],
            [11, 21, "#00FF00"],
            [16, 22, "#00FF00"],
            [17, 22, "#00FF00"],
            [18, 22, "#00FF00"],
            [19, 22, "#00FF00"],
            [20, 22, "#00FF00"],
            [21, 22, "#00FF00"],
            [20, 21, "#00FF00"],
            [19, 21, "#00FF00"],
            [19, 20, "#00FF00"],
            [18, 20, "#00FF00"],
            [18, 19, "#00FF00"],
            [17, 19, "#00FF00"],
            [17, 18, "#00FF00"],
            [16, 18, "#00FF00"],
            [16, 17, "#00FF00"],
            [16, 19, "#00FF00"],
            [16, 20, "#00FF00"],
            [16, 21, "#00FF00"],
            [17, 20, "#00FF00"],
            [17, 21, "#00FF00"],
            [18, 21, "#00FF00"],
            [8, 20, "#00FF00"],
            [8, 19, "#00FF00"],
            [8, 18, "#00FF00"],
            [8, 17, "#00FF00"],
            [8, 16, "#00FF00"],
            [9, 16, "#00FF00"],
            [10, 16, "#00FF00"],
            [11, 16, "#00FF00"],
            [12, 16, "#00FF00"],
            [11, 17, "#00FF00"],
            [10, 17, "#00FF00"],
            [9, 17, "#00FF00"],
            [10, 18, "#00FF00"],
            [9, 18, "#00FF00"],
            [9, 19, "#00FF00"],
            [7, 16, "#00FF00"],
            [7, 17, "#00FF00"],
            [7, 18, "#00FF00"],
            [7, 19, "#00FF00"],
            [7, 20, "#00FF00"],
            [7, 21, "#00FF00"],
            [17, 16, "#00FF00"],
            [18, 16, "#00FF00"],
            [19, 16, "#00FF00"],
            [20, 16, "#00FF00"],
            [21, 16, "#00FF00"],
            [22, 16, "#00FF00"],
            [22, 17, "#00FF00"],
            [22, 19, "#00FF00"],
            [22, 20, "#00FF00"],
            [22, 21, "#00FF00"],
            [22, 18, "#00FF00"],
            [21, 20, "#00FF00"],
            [21, 19, "#00FF00"],
            [20, 19, "#00FF00"],
            [20, 18, "#00FF00"],
            [19, 18, "#00FF00"],
            [19, 17, "#00FF00"],
            [18, 17, "#00FF00"],
            [21, 17, "#00FF00"],
            [21, 18, "#00FF00"],
            [20, 17, "#00FF00"],
            [1, 8, "#00FFFF"],
            [2, 7, "#00FFFF"],
            [3, 6, "#00FFFF"],
            [4, 5, "#00FFFF"],
            [5, 4, "#FF0000"],
            [6, 3, "#00FFFF"],
            [6, 2, "#00FFFF"],
            [7, 2, "#00FFFF"],
            [8, 1, "#00FFFF"],
            [7, 1, "#00FFFF"],
            [5, 1, "#00FFFF"],
            [4, 1, "#00FFFF"],
            [3, 1, "#00FFFF"],
            [2, 1, "#00FFFF"],
            [6, 1, "#00FFFF"],
            [5, 2, "#00FFFF"],
            [4, 2, "#00FFFF"],
            [3, 2, "#00FFFF"],
            [5, 3, "#00FFFF"],
            [4, 3, "#00FFFF"],
            [3, 5, "#00FFFF"],
            [3, 4, "#00FFFF"],
            [2, 3, "#00FFFF"],
            [1, 2, "#00FFFF"],
            [1, 3, "#00FFFF"],
            [1, 4, "#00FFFF"],
            [1, 5, "#00FFFF"],
            [1, 6, "#00FFFF"],
            [1, 7, "#00FFFF"],
            [2, 6, "#00FFFF"],
            [2, 5, "#00FFFF"],
            [2, 4, "#00FFFF"],
            [14, 9, "#00FFFF"],
            [14, 10, "#00FFFF"],
            [14, 11, "#00FFFF"],
            [14, 12, "#00FFFF"],
            [14, 13, "#00FFFF"],
            [15, 13, "#00FFFF"],
            [15, 12, "#00FFFF"],
            [15, 11, "#00FFFF"],
            [15, 10, "#00FFFF"],
            [15, 9, "#00FFFF"],
            [14, 24, "#00FFFF"],
            [14, 25, "#00FFFF"],
            [14, 26, "#00FFFF"],
            [14, 27, "#00FFFF"],
            [14, 28, "#00FFFF"],
            [15, 28, "#00FFFF"],
            [15, 27, "#00FFFF"],
            [15, 26, "#00FFFF"],
            [15, 25, "#00FFFF"],
            [15, 24, "#00FFFF"],
            [16, 12, "#FF0000"],
            [16, 11, "#FF0000"],
            [16, 10, "#FF0000"],
            [16, 4, "#FF0000"],
            [17, 4, "#FF0000"],
            [18, 4, "#FF0000"],
            [19, 4, "#FF0000"],
            [20, 4, "#FF0000"],
            [21, 4, "#FF0000"],
            [22, 4, "#FF0000"],
            [23, 4, "#FF0000"],
            [24, 4, "#FF0000"],
            [23, 5, "#FF0000"],
            [22, 5, "#FF0000"],
            [22, 6, "#FF0000"],
            [21, 6, "#FF0000"],
            [21, 7, "#FF0000"],
            [20, 7, "#FF0000"],
            [20, 8, "#FF0000"],
            [19, 8, "#FF0000"],
            [19, 9, "#FF0000"],
            [18, 9, "#FF0000"],
            [18, 10, "#FF0000"],
            [17, 10, "#FF0000"],
            [17, 11, "#FF0000"],
            [16, 9, "#FF0000"],
            [16, 8, "#FF0000"],
            [16, 7, "#FF0000"],
            [16, 6, "#FF0000"],
            [16, 5, "#FF0000"],
            [18, 5, "#FF0000"],
            [19, 5, "#FF0000"],
            [20, 5, "#FF0000"],
            [21, 5, "#FF0000"],
            [17, 6, "#FF0000"],
            [17, 8, "#FF0000"],
            [17, 9, "#FF0000"],
            [17, 7, "#FF0000"],
            [17, 5, "#FF0000"],
            [19, 6, "#FF0000"],
            [20, 6, "#FF0000"],
            [18, 6, "#FF0000"],
            [18, 7, "#FF0000"],
            [19, 7, "#FF0000"],
            [18, 8, "#FF0000"],
            [16, 14, "#FF0000"],
            [17, 14, "#FF0000"],
            [18, 14, "#FF0000"],
            [19, 14, "#FF0000"],
            [20, 13, "#FF0000"],
            [20, 14, "#FF0000"],
            [21, 14, "#FF0000"],
            [22, 14, "#FF0000"],
            [23, 14, "#FF0000"],
            [24, 14, "#FF0000"],
            [24, 7, "#FF0000"],
            [24, 8, "#FF0000"],
            [24, 9, "#FF0000"],
            [24, 10, "#FF0000"],
            [24, 11, "#FF0000"],
            [24, 12, "#FF0000"],
            [24, 13, "#FF0000"],
            [24, 6, "#FF0000"],
            [23, 7, "#FF0000"],
            [23, 8, "#FF0000"],
            [22, 8, "#FF0000"],
            [23, 9, "#FF0000"],
            [22, 9, "#FF0000"],
            [21, 9, "#FF0000"],
            [20, 10, "#FF0000"],
            [19, 11, "#FF0000"],
            [19, 12, "#FF0000"],
            [18, 12, "#FF0000"],
            [17, 13, "#FF0000"],
            [18, 13, "#FF0000"],
            [19, 13, "#FF0000"],
            [20, 12, "#FF0000"],
            [20, 11, "#FF0000"],
            [21, 11, "#FF0000"],
            [21, 10, "#FF0000"],
            [22, 10, "#FF0000"],
            [23, 11, "#FF0000"],
            [22, 11, "#FF0000"],
            [23, 10, "#FF0000"],
            [23, 12, "#FF0000"],
            [21, 12, "#FF0000"],
            [21, 13, "#FF0000"],
            [23, 13, "#FF0000"],
            [22, 12, "#FF0000"],
            [22, 13, "#FF0000"],
            [13, 4, "#FF0000"],
            [12, 4, "#FF0000"],
            [11, 4, "#FF0000"],
            [10, 4, "#FF0000"],
            [9, 4, "#FF0000"],
            [8, 4, "#FF0000"],
            [7, 4, "#FF0000"],
            [5, 6, "#FF0000"],
            [5, 7, "#FF0000"],
            [5, 8, "#FF0000"],
            [5, 9, "#FF0000"],
            [5, 10, "#FF0000"],
            [5, 11, "#FF0000"],
            [5, 12, "#FF0000"],
            [5, 13, "#FF0000"],
            [6, 13, "#FF0000"],
            [7, 13, "#FF0000"],
            [8, 13, "#FF0000"],
            [5, 14, "#FF0000"],
            [6, 14, "#FF0000"],
            [7, 14, "#FF0000"],
            [8, 14, "#FF0000"],
            [9, 14, "#FF0000"],
            [10, 14, "#FF0000"],
            [11, 14, "#FF0000"],
            [12, 14, "#FF0000"],
            [13, 14, "#FF0000"],
            [13, 5, "#FF0000"],
            [13, 6, "#FF0000"],
            [13, 7, "#FF0000"],
            [13, 8, "#FF0000"],
            [13, 9, "#FF0000"],
            [13, 11, "#FF0000"],
            [13, 10, "#FF0000"],
            [13, 12, "#FF0000"],
            [12, 13, "#FF0000"],
            [11, 13, "#FF0000"],
            [11, 12, "#FF0000"],
            [10, 12, "#FF0000"],
            [10, 11, "#FF0000"],
            [9, 11, "#FF0000"],
            [9, 10, "#FF0000"],
            [8, 9, "#FF0000"],
            [8, 10, "#FF0000"],
            [7, 10, "#FF0000"],
            [7, 9, "#FF0000"],
            [7, 8, "#FF0000"],
            [6, 8, "#FF0000"],
            [6, 7, "#FF0000"],
            [6, 5, "#FF0000"],
            [7, 5, "#FF0000"],
            [7, 6, "#FF0000"],
            [8, 6, "#FF0000"],
            [8, 7, "#FF0000"],
            [9, 7, "#FF0000"],
            [9, 8, "#FF0000"],
            [10, 8, "#FF0000"],
            [10, 9, "#FF0000"],
            [11, 10, "#FF0000"],
            [12, 10, "#FF0000"],
            [12, 11, "#FF0000"],
            [11, 9, "#FF0000"],
            [8, 5, "#FF0000"],
            [9, 5, "#FF0000"],
            [10, 5, "#FF0000"],
            [11, 5, "#FF0000"],
            [12, 5, "#FF0000"],
            [12, 6, "#FF0000"],
            [10, 6, "#FF0000"],
            [9, 6, "#FF0000"],
            [11, 6, "#FF0000"],
            [10, 7, "#FF0000"],
            [11, 7, "#FF0000"],
            [12, 7, "#FF0000"],
            [12, 8, "#FF0000"],
            [11, 8, "#FF0000"],
            [6, 10, "#FF0000"],
            [6, 9, "#FF0000"],
            [6, 11, "#FF0000"],
            [7, 12, "#FF0000"],
            [7, 11, "#FF0000"],
            [6, 12, "#FF0000"],
            [8, 11, "#FF0000"],
            [9, 12, "#FF0000"],
            [8, 12, "#FF0000"],
            [9, 13, "#FF0000"],
            [10, 13, "#FF0000"],
            [12, 9, "#FF0000"],
            [4, 7, "#4A86E8"],
            [4, 9, "#4A86E8"],
            [4, 8, "#4A86E8"],
            [4, 10, "#4A86E8"],
            [4, 12, "#4A86E8"],
            [4, 11, "#4A86E8"],
            [4, 13, "#4A86E8"],
            [4, 14, "#4A86E8"],
            [3, 14, "#4A86E8"],
            [2, 14, "#4A86E8"],
            [1, 14, "#4A86E8"],
            [1, 13, "#4A86E8"],
            [1, 12, "#4A86E8"],
            [1, 11, "#4A86E8"],
            [2, 10, "#4A86E8"],
            [1, 10, "#4A86E8"],
            [2, 9, "#4A86E8"],
            [3, 9, "#4A86E8"],
            [3, 8, "#4A86E8"],
            [3, 11, "#4A86E8"],
            [3, 10, "#4A86E8"],
            [2, 11, "#4A86E8"],
            [2, 12, "#4A86E8"],
            [2, 13, "#4A86E8"],
            [3, 13, "#4A86E8"],
            [3, 12, "#4A86E8"],
            [1, 15, "#4A86E8"],
            [2, 15, "#4A86E8"],
            [3, 15, "#4A86E8"],
            [4, 15, "#4A86E8"],
            [5, 15, "#4A86E8"],
            [6, 15, "#4A86E8"],
            [7, 15, "#4A86E8"],
            [8, 15, "#4A86E8"],
            [9, 15, "#4A86E8"],
            [10, 15, "#4A86E8"],
            [11, 15, "#4A86E8"],
            [12, 15, "#4A86E8"],
            [13, 15, "#4A86E8"],
            [8, 3, "#4A86E8"],
            [9, 3, "#4A86E8"],
            [9, 2, "#4A86E8"],
            [10, 2, "#4A86E8"],
            [10, 3, "#4A86E8"],
            [11, 3, "#4A86E8"],
            [11, 2, "#4A86E8"],
            [10, 1, "#0000FF"],
            [11, 1, "#0000FF"],
            [12, 1, "#0000FF"],
            [13, 1, "#0000FF"],
            [13, 3, "#0000FF"],
            [12, 3, "#0000FF"],
            [12, 2, "#0000FF"],
            [13, 2, "#0000FF"],
            [1, 16, "#0000FF"],
            [1, 17, "#0000FF"],
            [1, 18, "#0000FF"],
            [1, 20, "#0000FF"],
            [1, 21, "#0000FF"],
            [1, 22, "#0000FF"],
            [1, 23, "#0000FF"],
            [2, 23, "#0000FF"],
            [3, 23, "#0000FF"],
            [4, 23, "#0000FF"],
            [5, 23, "#0000FF"],
            [1, 19, "#0000FF"],
            [2, 16, "#0000FF"],
            [3, 16, "#0000FF"],
            [4, 16, "#0000FF"],
            [5, 16, "#0000FF"],
            [6, 16, "#0000FF"],
            [6, 17, "#0000FF"],
            [6, 19, "#0000FF"],
            [6, 20, "#0000FF"],
            [6, 21, "#0000FF"],
            [6, 22, "#0000FF"],
            [6, 18, "#0000FF"],
            [5, 18, "#0000FF"],
            [5, 17, "#0000FF"],
            [4, 17, "#0000FF"],
            [3, 17, "#0000FF"],
            [2, 17, "#0000FF"],
            [2, 19, "#0000FF"],
            [2, 20, "#0000FF"],
            [2, 22, "#0000FF"],
            [4, 22, "#0000FF"],
            [5, 22, "#0000FF"],
            [5, 20, "#0000FF"],
            [5, 19, "#0000FF"],
            [4, 18, "#0000FF"],
            [3, 18, "#0000FF"],
            [2, 18, "#0000FF"],
            [3, 19, "#0000FF"],
            [4, 19, "#0000FF"],
            [3, 21, "#0000FF"],
            [4, 21, "#0000FF"],
            [3, 20, "#0000FF"],
            [4, 20, "#0000FF"],
            [5, 21, "#0000FF"],
            [2, 21, "#0000FF"],
            [3, 22, "#0000FF"],
            [1, 27, "#5CB85C"],
            [1, 26, "#5CB85C"],
            [1, 25, "#5CB85C"],
            [2, 24, "#5CB85C"],
            [1, 24, "#5CB85C"],
            [3, 24, "#5CB85C"],
            [4, 24, "#5CB85C"],
            [3, 25, "#5CB85C"],
            [2, 25, "#5CB85C"],
            [2, 26, "#5CB85C"],
            [16, 15, "#5CB85C"],
            [17, 15, "#5CB85C"],
            [18, 15, "#5CB85C"],
            [19, 15, "#5CB85C"],
            [20, 15, "#5CB85C"],
            [21, 15, "#5CB85C"],
            [22, 15, "#5CB85C"],
            [23, 15, "#5CB85C"],
            [24, 15, "#5CB85C"],
            [24, 16, "#5CB85C"],
            [24, 17, "#5CB85C"],
            [24, 18, "#5CB85C"],
            [24, 19, "#5CB85C"],
            [24, 20, "#5CB85C"],
            [24, 21, "#5CB85C"],
            [24, 22, "#5CB85C"],
            [24, 23, "#5CB85C"],
            [23, 21, "#5CB85C"],
            [23, 20, "#5CB85C"],
            [23, 19, "#5CB85C"],
            [23, 18, "#5CB85C"],
            [23, 17, "#5CB85C"],
            [23, 16, "#5CB85C"],
            [23, 22, "#5CB85C"],
            [17, 1, "#FFFF00"],
            [16, 1, "#FFFF00"],
            [16, 2, "#FFFF00"],
            [16, 3, "#FFFF00"],
            [17, 3, "#FFFF00"],
            [18, 3, "#FFFF00"],
            [19, 3, "#FFFF00"],
            [20, 3, "#FFFF00"],
            [21, 3, "#FFFF00"],
            [22, 3, "#FFFF00"],
            [23, 3, "#FFFF00"],
            [24, 3, "#FFFF00"],
            [25, 3, "#FFFF00"],
            [26, 2, "#FFFF00"],
            [26, 1, "#FFFF00"],
            [27, 1, "#FFFF00"],
            [24, 1, "#FFFF00"],
            [23, 1, "#FFFF00"],
            [22, 1, "#FFFF00"],
            [20, 1, "#FFFF00"],
            [19, 1, "#FFFF00"],
            [18, 1, "#FFFF00"],
            [21, 1, "#FFFF00"],
            [25, 1, "#FFFF00"],
            [25, 2, "#FFFF00"],
            [24, 2, "#FFFF00"],
            [23, 2, "#FFFF00"],
            [22, 2, "#FFFF00"],
            [21, 2, "#FFFF00"],
            [20, 2, "#FFFF00"],
            [19, 2, "#FFFF00"],
            [18, 2, "#FFFF00"],
            [17, 2, "#FFFF00"],
            [16, 28, "#FFFF00"],
            [17, 27, "#FFFF00"],
            [18, 26, "#FFFF00"],
            [19, 25, "#FFFF00"],
            [20, 24, "#FFFF00"],
            [21, 23, "#FFFF00"],
            [13, 28, "#FFFF00"],
            [12, 27, "#FFFF00"],
            [11, 26, "#FFFF00"],
            [10, 25, "#FFFF00"],
            [9, 24, "#FFFF00"],
            [8, 23, "#FFFF00"],
            [7, 24, "#FFFF00"],
            [6, 25, "#FFFF00"],
            [5, 26, "#FFFF00"],
            [4, 27, "#FFFF00"],
            [3, 28, "#FFFF00"],
            [22, 24, "#FFFF00"],
            [23, 25, "#FFFF00"],
            [24, 26, "#FFFF00"],
            [25, 27, "#FFFF00"],
            [26, 28, "#FFFF00"],
            [2, 28, "#FF9900"],
            [3, 27, "#FF9900"],
            [4, 26, "#FF9900"],
            [5, 25, "#FF9900"],
            [6, 24, "#FF9900"],
            [7, 23, "#FF9900"],
            [10, 23, "#FF9900"],
            [12, 23, "#FF9900"],
            [13, 23, "#FF9900"],
            [11, 23, "#FF9900"],
            [9, 23, "#FF9900"],
            [10, 24, "#FF9900"],
            [11, 24, "#FF9900"],
            [11, 25, "#FF9900"],
            [12, 25, "#FF9900"],
            [12, 26, "#FF9900"],
            [13, 26, "#FF9900"],
            [13, 27, "#FF9900"],
            [13, 25, "#FF9900"],
            [13, 24, "#FF9900"],
            [12, 24, "#FF9900"],
            [22, 23, "#FF9900"],
            [23, 24, "#FF9900"],
            [27, 28, "#FF9900"],
            [26, 27, "#FF9900"],
            [25, 26, "#FF9900"],
            [24, 25, "#FF9900"],
            [19, 23, "#FF9900"],
            [18, 23, "#FF9900"],
            [17, 23, "#FF9900"],
            [16, 23, "#FF9900"],
            [16, 24, "#FF9900"],
            [20, 23, "#FF9900"],
            [19, 24, "#FF9900"],
            [18, 24, "#FF9900"],
            [17, 25, "#FF9900"],
            [17, 24, "#FF9900"],
            [16, 25, "#FF9900"],
            [16, 26, "#FF9900"],
            [16, 27, "#FF9900"],
            [18, 25, "#FF9900"],
            [17, 26, "#FF9900"],
            [8, 24, "#A61C00"],
            [8, 26, "#A61C00"],
            [8, 25, "#A61C00"],
            [8, 27, "#A61C00"],
            [8, 28, "#A61C00"],
            [7, 28, "#A61C00"],
            [6, 28, "#A61C00"],
            [5, 28, "#A61C00"],
            [4, 28, "#A61C00"],
            [9, 28, "#A61C00"],
            [10, 28, "#A61C00"],
            [11, 28, "#A61C00"],
            [12, 28, "#A61C00"],
            [21, 24, "#A61C00"],
            [21, 25, "#A61C00"],
            [21, 26, "#A61C00"],
            [21, 27, "#A61C00"],
            [21, 28, "#A61C00"],
            [22, 28, "#A61C00"],
            [23, 28, "#A61C00"],
            [24, 28, "#A61C00"],
            [25, 28, "#A61C00"],
            [20, 28, "#A61C00"],
            [19, 28, "#A61C00"],
            [18, 28, "#A61C00"],
            [17, 28, "#A61C00"],
            [25, 23, "#980000"],
            [26, 23, "#980000"],
            [27, 23, "#980000"],
            [28, 23, "#980000"],
            [28, 24, "#980000"],
            [28, 25, "#980000"],
            [28, 26, "#980000"],
            [28, 27, "#980000"],
            [27, 26, "#980000"],
            [27, 25, "#980000"],
            [27, 24, "#980000"],
            [26, 24, "#980000"],
            [26, 25, "#980000"],
            [25, 24, "#980000"],
            [25, 6, "#980000"],
            [26, 6, "#980000"],
            [27, 6, "#980000"],
            [28, 6, "#980000"],
            [28, 5, "#980000"],
            [28, 4, "#980000"],
            [28, 3, "#980000"],
            [28, 2, "#980000"],
            [27, 3, "#980000"],
            [27, 4, "#980000"],
            [26, 4, "#980000"],
            [26, 5, "#980000"],
            [25, 5, "#980000"],
            [27, 5, "#980000"],
            [5, 27, "#000000"],
            [6, 26, "#000000"],
            [7, 25, "#000000"],
            [7, 26, "#000000"],
            [7, 27, "#000000"],
            [6, 27, "#000000"],
            [9, 25, "#000000"],
            [9, 26, "#000000"],
            [9, 27, "#000000"],
            [10, 27, "#000000"],
            [10, 26, "#000000"],
            [11, 27, "#000000"],
            [18, 27, "#000000"],
            [19, 26, "#000000"],
            [20, 25, "#000000"],
            [20, 26, "#000000"],
            [20, 27, "#000000"],
            [19, 27, "#000000"],
            [22, 26, "#000000"],
            [22, 25, "#000000"],
            [23, 26, "#000000"],
            [24, 27, "#000000"],
            [22, 27, "#000000"],
            [23, 27, "#000000"],
            [28, 7, "#434343"],
            [28, 9, "#434343"],
            [28, 8, "#434343"],
            [28, 10, "#434343"],
            [28, 11, "#434343"],
            [28, 12, "#434343"],
            [28, 13, "#434343"],
            [27, 10, "#434343"],
            [26, 10, "#434343"],
            [25, 10, "#434343"],
            [27, 7, "#434343"],
            [25, 7, "#434343"],
            [26, 7, "#434343"],
            [25, 13, "#434343"],
            [26, 13, "#434343"],
            [27, 13, "#434343"],
            [25, 8, "#666666"],
            [26, 8, "#666666"],
            [27, 8, "#666666"],
            [27, 9, "#666666"],
            [26, 9, "#666666"],
            [25, 9, "#666666"],
            [25, 11, "#666666"],
            [26, 11, "#666666"],
            [27, 11, "#666666"],
            [27, 12, "#666666"],
            [25, 12, "#666666"],
            [26, 12, "#666666"],
            [25, 14, "#CCCCCC"],
            [25, 15, "#CCCCCC"],
            [26, 15, "#CCCCCC"],
            [26, 14, "#CCCCCC"],
            [27, 14, "#CCCCCC"],
            [28, 14, "#CCCCCC"],
            [28, 15, "#CCCCCC"],
            [27, 15, "#CCCCCC"],
            [28, 16, "#CCCCCC"],
            [27, 16, "#CCCCCC"],
            [26, 16, "#CCCCCC"],
            [25, 16, "#CCCCCC"],
            [25, 18, "#D9D9D9"],
            [25, 19, "#D9D9D9"],
            [25, 20, "#D9D9D9"],
            [25, 21, "#D9D9D9"],
            [26, 21, "#D9D9D9"],
            [27, 21, "#D9D9D9"],
            [28, 21, "#D9D9D9"],
            [28, 20, "#D9D9D9"],
            [28, 19, "#D9D9D9"],
            [28, 18, "#D9D9D9"],
            [26, 18, "#D9D9D9"],
            [27, 19, "#D9D9D9"],
            [27, 18, "#D9D9D9"],
            [27, 20, "#D9D9D9"],
            [26, 19, "#D9D9D9"],
            [26, 20, "#D9D9D9"],
            [25, 17, "#000000"],
            [26, 17, "#000000"],
            [27, 17, "#000000"],
            [28, 17, "#000000"],
            [28, 22, "#000000"],
            [27, 22, "#000000"],
            [26, 22, "#000000"],
            [25, 22, "#000000"],
        ],
    },
];
